import React from 'react';
import { EpicGamesNavigation } from '@wf-components/navigation-react';
import { useSelector } from 'react-redux';
import { selectConfigState } from '../../selectors/config.selector';
import { selectAccountState } from '../../selectors/account.selector';
import { getLocale } from '../../utils/local.utils';
import { useLogoutRedirect } from '../../hooks/useLogoutRedirect';

export const GlobalNavWrapper = (): React.JSX.Element => {
    const configState = useSelector(selectConfigState);
    const { isLoggedIn, accountInfo } = useSelector(selectAccountState);
    const { generateLogoutUrl } = useLogoutRedirect();
    const logoutUrl = generateLogoutUrl();
    const locale = getLocale();

    const serverUrl = configState.globalBase;

    return (
        <>
            <EpicGamesNavigation
                domain={serverUrl}
                locale={locale}
                isLoggedIn={isLoggedIn}
                displayName={accountInfo?.displayName}
                disableSearch={true}
                localeOptions={configState?.localeOptions as any}
                signOutLinkHref={logoutUrl}
            />
        </>
    );
};
